import { createContext, useContext, useMemo } from "react";
import { useContentPages } from "../../features/content/hooks/useContentPages";
import { useContentVersion } from "../../features/content/hooks/useContentVersion";

const ContentContext = createContext();
export const useContentContext = () => useContext(ContentContext);

const ContentProvider = ({ children }) => {
  const contentVersion = useContentVersion();
  const {
    getPagesByLanding,
    getPageBySlug,
    getPageBySlugFromBackend,
    upsertPageConfig,
    deletePageConfig,
  } = useContentPages(contentVersion);

  const value = useMemo(() => ({
    getPagesByLanding,
    getPageBySlug,
    getPageBySlugFromBackend,
    upsertPageConfig,
    deletePageConfig,
  }), [
    getPagesByLanding,
    getPageBySlug,
    getPageBySlugFromBackend,
    upsertPageConfig,
    deletePageConfig,
  ]);

  return (
    <ContentContext.Provider value={value}>
      {children}
    </ContentContext.Provider>
  );
};

export default ContentProvider;
